
import Vue from "vue";
import ViewPDFService from '@/services/ViewPDFService';
import axios from "axios";

export default Vue.extend({
    name: 'CustomViewPDF',
    props: {
        link: {
            type: String,
        },
    },
    data(){
        return {
            dialog: false,
            dialogInterno: false,
            dialogRecibo: false,
            dialogNewPaymentFormat: false,
            documento: null,
            documento2: null,
            pagoEnLineaVar: 0 as any,
            pagoEnLineaPagado: 0 as any,
            folioPago: 0 as any,
            tipoPago: '' as any,
            establecimientoPago: 0 as any,
            dataPagoEnlinea: {
                id_establecimiento: 0 as any,
                id_servicio: 0 as any,
                estatus_edo_cuenta: 0 as any,
                folio_estado_cuenta: 0 as any,
            },
            disabled: false
        }
    },
    watch: {
        dialog(){
            if(this.dialog){
                this.getPDF();
            } else {
                this.documento = null
            }
        }
    },
    methods: {
        getPDF(){
            this.disabled = true;
            ViewPDFService.viewPDF(this.link, {}, 'GET', 'Temp')
            .then((response)=>{
                let file = new Blob([response.data],{type: response.headers['content-type']});
                const url = window.URL.createObjectURL(file);
                const tipoArchivo = 'Titulo'
                //@ts-ignore
                this.documento = {
                    title: tipoArchivo,
                    url: url,
                    mime: response.headers['content-type'] 
                }
                //this.dialog= true;

                /*this.pagoEnLineaVar = 0;
                this.dataPagoEnlinea.id_establecimiento = 0;
                this.dataPagoEnlinea.id_servicio = 0;
                this.dataPagoEnlinea.estatus_edo_cuenta = 0;
                this.dataPagoEnlinea.folio_estado_cuenta = 0;
                this.pagoEnLineaPagado = 0;
                //basura
                let busquedaClave = this.link.indexOf("viewestadocuentars");
                if (busquedaClave >= 0) {
                    //basura
                    this.disabled = false;
                    this.dialogInterno = true;
                    this.dialogRecibo = true;
                    let busquedaId = this.link.split("viewestadocuentars")[1];
                    let busquedaLimpia = busquedaId.split("/")[1];
                    this.pagoEnLineaVar = busquedaLimpia;
                    ViewPDFService.getDataEstablecimiento(this.pagoEnLineaVar).then((response)=>{
                        console.log(response.data);
                        //Verificar si ya fue pagado
                        if (response.data.pago_linea_basura != null) {
                            this.pagoEnLineaVar = 0;
                            this.pagoEnLineaPagado = 1;
                            this.folioPago = response.data.pago_linea_basura.id_folio_pago;
                            this.establecimientoPago = response.data.external_id;
                            this.tipoPago = 'RESIDUOS SÓLIDOS';
                        }
                        if (response.data.pago_linea_basura_opb_pendiente == null) {
                            this.folioPago = response.data.pago_linea_basura_opb_pendiente.id_folio_pago;
                        }
                        this.dataPagoEnlinea.id_establecimiento = response.data.external_id;
                        this.dataPagoEnlinea.id_servicio = 1750;
                        this.dataPagoEnlinea.estatus_edo_cuenta = 'A';
                        this.dataPagoEnlinea.folio_estado_cuenta = '1';
                        console.log(this.dataPagoEnlinea);
                    })
                }else{
                    //anuenciapc
                    let busquedaClave = this.link.indexOf("viewestadocuentaanuencia");
                    if (busquedaClave >= 0) {
                        this.disabled = false;
                        this.dialogInterno = true;
                        let busquedaId = this.link.split("viewestadocuentaanuencia")[1];
                        let busquedaLimpia = busquedaId.split("/")[1];
                        this.pagoEnLineaVar = busquedaLimpia;
                        ViewPDFService.getDataEstablecimiento(this.pagoEnLineaVar).then((response)=>{
                            console.log(response.data);
                            //Verificar si ya fue pagado
                            if (response.data.pago_linea_anuencia != null) {
                                this.pagoEnLineaVar = 0;
                                this.pagoEnLineaPagado = 1;
                                this.folioPago = response.data.pago_linea_anuencia.id_folio_pago;
                                this.establecimientoPago = response.data.external_id;
                                this.tipoPago = 'anuencia de protección civil';
                            }
                            if (response.data.pago_linea_anuencia_opb_pendiente == null) {
                                this.folioPago = response.data.pago_linea_anuencia_opb_pendiente.id_folio_pago;
                            }
                            this.dataPagoEnlinea.id_establecimiento = response.data.external_id;
                            this.dataPagoEnlinea.id_servicio = 1752;
                            this.dataPagoEnlinea.estatus_edo_cuenta = 'A';
                            this.dataPagoEnlinea.folio_estado_cuenta = '1';
                            console.log(this.dataPagoEnlinea);
                        })
                    }else{
                        //alcohol
                        let busquedaClave = this.link.indexOf("viewEdoCuentaAlcohol");
                        if (busquedaClave >= 0) {
                            this.disabled = false;
                            this.dialogInterno = true;
                            let busquedaLicencia = this.link.split("licencia")[1];
                            let busquedaLicenciaLimpia = busquedaLicencia.split("/")[1];
                            let busquedaId = this.link.split("viewEdoCuentaAlcohol")[1];
                            let busquedaLimpia = busquedaId.split("/")[1];
                            this.pagoEnLineaVar = busquedaLimpia;
                            ViewPDFService.getDataEstablecimientoLicenciaAlcohol(busquedaLicenciaLimpia, this.pagoEnLineaVar).then((response)=>{
                                console.log(response.data);
                                //Verificar si ya fue pagado
                                if (response.data.solicitud.pago_linea_alcohol != null) {
                                    this.pagoEnLineaVar = 0;
                                    this.pagoEnLineaPagado = 1;
                                    this.folioPago = response.data.solicitud.pago_linea_alcohol.id_folio_pago;
                                    this.establecimientoPago = response.data.locacion.external_id;
                                    this.tipoPago = 'licencia de alcohol';
                                }
                                if (response.data.solicitud.pago_linea_opb_pendiente == null) {
                                    this.folioPago = response.data.solicitud.pago_linea_opb_pendiente.id_folio_pago;
                                }
                                this.dataPagoEnlinea.id_establecimiento = busquedaLicenciaLimpia;
                                this.dataPagoEnlinea.id_servicio = 1751;
                                this.dataPagoEnlinea.estatus_edo_cuenta = 'A';
                                this.dataPagoEnlinea.folio_estado_cuenta = busquedaLicenciaLimpia;
                                console.log(this.dataPagoEnlinea);
                            })
                        }else{
                            //horarios-musica
                            let busquedaClave = this.link.indexOf("viewEdoCuentaFiscalizacion");
                            if (busquedaClave >= 0) {
                                this.disabled = false;
                                this.dialogInterno = true;
                                let busquedaLicencia = this.link.split("licencia")[1];
                                let busquedaLicenciaLimpia = busquedaLicencia.split("/")[1];
                                let busquedaId = this.link.split("viewEdoCuentaFiscalizacion")[1];
                                let busquedaLimpia = busquedaId.split("/")[1];
                                this.pagoEnLineaVar = busquedaLimpia;
                                ViewPDFService.getDataEstablecimientoHorariosExtra(busquedaLicenciaLimpia, this.pagoEnLineaVar).then((response)=>{
                                    console.log(response.data);
                                    //Verificar si ya fue pagado
                                    if (response.data.solicitud.edo_cuenta_aprobado.pago_linea_opb != null) {
                                        this.pagoEnLineaVar = 0;
                                        this.pagoEnLineaPagado = 1;
                                        this.folioPago = response.data.solicitud.edo_cuenta_aprobado.pago_linea_opb.id_folio_pago;
                                        this.establecimientoPago = response.data.solicitud.edo_cuenta_aprobado.referencia_id;
                                        this.tipoPago = 'extra';
                                    }
                                    if (response.data.solicitud.edo_cuenta_aprobado.pago_linea_opb_pendiente != null) {
                                        this.folioPago = response.data.solicitud.edo_cuenta_aprobado.pago_linea_opb_pendiente.id_folio_pago;
                                    }
                                    this.dataPagoEnlinea.id_establecimiento = response.data.solicitud.edo_cuenta_aprobado.folio;
                                    this.dataPagoEnlinea.id_servicio = 1754;
                                    this.dataPagoEnlinea.estatus_edo_cuenta = 'A';
                                    this.dataPagoEnlinea.folio_estado_cuenta = response.data.solicitud.tipo;
                                    console.log(this.dataPagoEnlinea);
                                })
                            }else{
                                //constancia-uso-suelo
                                let busquedaClave = this.link.indexOf("viewestadocuenta");
                                let busquedaTipo = this.link.indexOf("constancia_uso_suelo");
                                if (busquedaClave >= 0 && busquedaTipo >= 0) {
                                    this.disabled = false;
                                    this.dialogInterno = true;
                                    let busqueda = this.link.split("constancia_uso_suelo")[1];
                                    let busquedaLimpia = busqueda.split("/")[1];
                                    this.pagoEnLineaVar = busquedaLimpia;
                                    ViewPDFService.getDataEstablecimientoConstanciaSuelo(this.pagoEnLineaVar).then((response)=>{
                                        console.log(response.data);
                                        //Verificar si ya fue pagado
                                        if (response.data.solicitud.pago_linea_opb != null) {
                                            this.pagoEnLineaVar = 0;
                                            this.pagoEnLineaPagado = 1;
                                            this.folioPago = response.data.solicitud.pago_linea_opb.id_folio_pago;
                                            this.establecimientoPago = response.data.locacion.external_id;
                                            this.tipoPago = 'suelo';
                                        }
                                        if (response.data.solicitud.pago_linea_opb_pendiente != null) {
                                            this.folioPago = response.data.solicitud.pago_linea_opb_pendiente.id_folio_pago;
                                        }
                                        this.dataPagoEnlinea.id_establecimiento = response.data.locacion.external_id;
                                        this.dataPagoEnlinea.id_servicio = 1755;
                                        this.dataPagoEnlinea.estatus_edo_cuenta = 'A';
                                        this.dataPagoEnlinea.folio_estado_cuenta = '1';
                                        console.log(this.dataPagoEnlinea);
                                    })
                                }else{
                                    //anuncio-externo
                                    let busquedaClave = this.link.indexOf("viewestadocuenta");
                                    let busquedaTipo = this.link.indexOf("anuncioexterno");
                                    if (busquedaClave >= 0 && busquedaTipo >= 0) {
                                        this.disabled = false;
                                        this.dialogInterno = true;
                                        let busqueda = this.link.split("anuncioexterno")[1];
                                        let busquedaLimpia = busqueda.split("/")[1];
                                        this.pagoEnLineaVar = busquedaLimpia;
                                        ViewPDFService.getDataEstablecimientoAnuncioExterno(this.pagoEnLineaVar).then((response)=>{
                                            console.log(response.data);
                                            //Verificar si ya fue pagado
                                            if (response.data.pago_linea_opb != null) {
                                                this.pagoEnLineaVar = 0;
                                                this.pagoEnLineaPagado = 1;
                                                this.folioPago = response.data.pago_linea_opb.id_folio_pago;
                                                this.establecimientoPago = response.data.folio.replace('/','-');
                                                this.tipoPago = 'anuncio en vía pública';
                                            }
                                            this.dataPagoEnlinea.id_establecimiento = response.data.folio;
                                            this.dataPagoEnlinea.id_servicio = 1756;
                                            this.dataPagoEnlinea.estatus_edo_cuenta = 'A';
                                            this.dataPagoEnlinea.folio_estado_cuenta = 'CLAVE';
                                            console.log(this.dataPagoEnlinea);
                                        })
                                    }else{
                                        //anuncio
                                        let busquedaClave = this.link.indexOf("viewestadocuenta");
                                        let busquedaTipo = this.link.indexOf("anuncio");
                                        if (busquedaClave >= 0 && busquedaTipo >= 0) {
                                            this.disabled = false;
                                            this.dialogInterno = true;
                                            let busqueda = this.link.split("anuncio")[1];
                                            let busquedaLimpia = busqueda.split("/")[1];
                                            this.pagoEnLineaVar = busquedaLimpia;
                                            ViewPDFService.getDataEstablecimientoAnuncio(this.pagoEnLineaVar).then((response)=>{
                                                console.log(response.data);
                                                //Verificar si ya fue pagado
                                                if (response.data.solicitud.pago_linea_opb != null) {
                                                    this.pagoEnLineaVar = 0;
                                                    this.pagoEnLineaPagado = 1;
                                                    this.folioPago = response.data.solicitud.pago_linea_opb.id_folio_pago;
                                                    this.establecimientoPago = response.data.solicitud.folio.replace('/','-');
                                                    this.tipoPago = 'anuncio publicitario';
                                                }
                                                if (response.data.solicitud.pago_linea_opb_pendiente != null) {
                                                    this.folioPago = response.data.solicitud.pago_linea_opb_pendiente.id_folio_pago;
                                                }
                                                this.dataPagoEnlinea.id_establecimiento = response.data.solicitud.folio;
                                                this.dataPagoEnlinea.id_servicio = 1756;
                                                this.dataPagoEnlinea.estatus_edo_cuenta = 'A';
                                                this.dataPagoEnlinea.folio_estado_cuenta = 'ESTABLECIMIENTO';
                                                console.log(this.dataPagoEnlinea);
                                            })
                                        }else{
                                            //extemporaneo
                                            let busquedaClave = this.link.indexOf("viewEstadoCuentaExtemporaneo");
                                            if (busquedaClave >= 0) {
                                                this.disabled = false;
                                                this.dialogInterno = true;
                                                let busquedaId = this.link.split("viewEstadoCuentaExtemporaneo")[1];
                                                let busquedaLimpia = busquedaId.split("/")[1];
                                                this.pagoEnLineaVar = busquedaLimpia;
                                                ViewPDFService.getDataEstablecimientoExtemporaneo(this.pagoEnLineaVar).then((response)=>{
                                                    console.log(response.data);
                                                    //Verificar si ya fue pagado
                                                    if (response.data.pago_linea_extemporaneo != null) {
                                                        this.pagoEnLineaVar = 0;
                                                        this.pagoEnLineaPagado = 1;
                                                        this.folioPago = response.data.pago_linea_extemporaneo.id_folio_pago;
                                                        this.establecimientoPago = response.data.locacion.external_id;
                                                        this.tipoPago = 'extemporaneo';
                                                    }
                                                    if (response.data.pago_linea_opb_pendiente != null) {
                                                        this.folioPago = response.data.pago_linea_opb_pendiente.id_folio_pago;
                                                    }
                                                    this.dataPagoEnlinea.id_establecimiento = response.data.folio;
                                                    this.dataPagoEnlinea.id_servicio = 1753;
                                                    this.dataPagoEnlinea.estatus_edo_cuenta = 'A';
                                                    this.dataPagoEnlinea.folio_estado_cuenta = '1';
                                                    console.log(this.dataPagoEnlinea);
                                                })
                                            }else{
                                                //piso y basura de mercados   
                                                let busquedaClave = this.link.indexOf("verEstadoCuentaMercadoAprobado");
                                                if (busquedaClave >= 0) {
                                                    let busquedaId = this.link.split("verEstadoCuentaMercadoAprobado")[1];
                                                    let busquedaLimpia = busquedaId.split("/")[2];
                                                    this.pagoEnLineaVar = busquedaLimpia;
                                                    ViewPDFService.getDataEstablecimientoMercado(this.pagoEnLineaVar).then((response)=>{
                                                        console.log(response.data);
                                                        //Verificar si ya fue pagado
                                                        if (response.data.pago_linea_opb != null) {
                                                            this.pagoEnLineaVar = 0;
                                                            this.pagoEnLineaPagado = 1;
                                                            this.folioPago = response.data.pago_linea_opb.id_folio_pago;
                                                            this.establecimientoPago = response.data.id_local_mercado;
                                                            this.tipoPago = 'piso y basura de mercados';
                                                        }
                                                        if (response.data.pago_linea_opb_pendiente != null) {
                                                            this.folioPago = response.data.pago_linea_opb_pendiente.id_folio_pago;
                                                            this.openNewPaymentFormat();
                                                        }
                                                        this.dataPagoEnlinea.id_establecimiento = response.data.folio;
                                                        this.dataPagoEnlinea.id_servicio = 1755;
                                                        this.dataPagoEnlinea.estatus_edo_cuenta = 'A';
                                                        this.dataPagoEnlinea.folio_estado_cuenta = 'CLAVE';
                                                        console.log(this.dataPagoEnlinea);
                                                    })
                                                }else{
                                                    //cesion derecho mercados  
                                                    let busquedaClave = this.link.indexOf("documentacion");
                                                    if (busquedaClave >= 0) {
                                                        this.disabled = false;
                                                        this.dialogInterno = true;
                                                        let busquedaId = this.link.split("documentacion")[1];
                                                        let busquedaLimpia = busquedaId.split("/")[1];
                                                        this.pagoEnLineaVar = busquedaLimpia;
                                                        ViewPDFService.getDataCesionDerecho(this.pagoEnLineaVar).then((response)=>{
                                                            console.log(response.data);
                                                            //Verificar si ya fue pagado
                                                            if (response.data.pago_linea_opb != null) {
                                                                this.pagoEnLineaVar = 0;
                                                                this.pagoEnLineaPagado = 1;
                                                                this.folioPago = response.data.pago_linea_opb.id_folio_pago;
                                                                this.establecimientoPago = response.data.id_local_mercado;
                                                                this.tipoPago = 'cesion derecho mercados';
                                                            }
                                                            if (response.data.pago_linea_opb_pendiente != null) {
                                                                this.folioPago = response.data.pago_linea_opb_pendiente.id_folio_pago;
                                                            }
                                                            this.dataPagoEnlinea.id_establecimiento = response.data.folio;
                                                            this.dataPagoEnlinea.id_servicio = 1755;
                                                            this.dataPagoEnlinea.estatus_edo_cuenta = 'A';
                                                            this.dataPagoEnlinea.folio_estado_cuenta = 'CLAVE';
                                                            console.log(this.dataPagoEnlinea);
                                                        })
                                                    }else{
                                                        //arrendamiento mercados 
                                                        let busquedaClave = this.link.indexOf("SolicitudArrendamientoAdmin");
                                                        if (busquedaClave >= 0) {
                                                            this.disabled = false;
                                                            this.dialogInterno = true;
                                                            let busquedaId = this.link.split("SolicitudArrendamientoAdmin")[1];
                                                            let busquedaLimpia = busquedaId.split("/")[3];
                                                            this.pagoEnLineaVar = busquedaLimpia;
                                                            ViewPDFService.getDataArrendamiento(this.pagoEnLineaVar).then((response)=>{
                                                                console.log(response.data);
                                                                //Verificar si ya fue pagado
                                                                if (response.data.pago_linea_opb != null) {
                                                                    this.pagoEnLineaVar = 0;
                                                                    this.pagoEnLineaPagado = 1;
                                                                    this.folioPago = response.data.pago_linea_opb.id_folio_pago;
                                                                    this.establecimientoPago = response.data.id_local_mercado;
                                                                    this.tipoPago = 'arrendamiento mercados';
                                                                }
                                                                if (response.data.pago_linea_opb_pendiente != null) {
                                                                    this.folioPago = response.data.pago_linea_opb_pendiente.id_folio_pago;
                                                                }
                                                                this.dataPagoEnlinea.id_establecimiento = response.data.folio;
                                                                this.dataPagoEnlinea.id_servicio = 1755;
                                                                this.dataPagoEnlinea.estatus_edo_cuenta = 'A';
                                                                this.dataPagoEnlinea.folio_estado_cuenta = 'CLAVE';
                                                                console.log(this.dataPagoEnlinea);
                                                            })
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }*/
                this.dialogInterno = true;
                this.disabled = false;
            }).catch((error) => {
                this.disabled = false;
            })
        },
        pagoEnLinea(){
            const url = 'https://sistemas2.opb.gob.mx/pagosOnline/pagos_linea.php';
            const ancho = 800;
            const alto = 600;

            // Centrar la ventana flotante
            const izquierda = (window.screen.width / 2) - (ancho / 2);
            const arriba = (window.screen.height / 2) - (alto / 2);

            // Crear un formulario y enviarlo en una nueva ventana
            const formulario = document.createElement('form');
            formulario.method = 'post';
            formulario.action = url;
            formulario.target = 'ventanaFlotante';
            formulario.style.display = 'none'; // Ocultar el formulario

            // Crear los campos del formulario
            const campos = [
                //Basura OK
                { name: 'idServicio', value: this.dataPagoEnlinea.id_servicio },
                { name: 'claveEstablecimiento', value: this.dataPagoEnlinea.id_establecimiento },
                { name: 'estatusEstadoCuenta', value: this.dataPagoEnlinea.estatus_edo_cuenta },
                { name: 'folioEstadoCuenta', value: this.dataPagoEnlinea.folio_estado_cuenta }

                //Anuencia OK
                //{ name: 'idServicio', value: '1752' },
                //{ name: 'claveEstablecimiento', value: '30636' },
                //{ name: 'estatusEstadoCuenta', value: 'A' },
                //{ name: 'folioEstadoCuenta', value: '1' }

                //Extemporáneo OK
                //{ name: 'idServicio', value: '1753' },
                //{ name: 'claveEstablecimiento', value: '30567' },
                //{ name: 'estatusEstadoCuenta', value: 'A' },
                //{ name: 'folioEstadoCuenta', value: '2024' }

                //Alcohol OK
                //{ name: 'idServicio', value: '1751' },
                //{ name: 'claveEstablecimiento', value: '30538' },
                //{ name: 'estatusEstadoCuenta', value: 'A' },
                //{ name: 'folioEstadoCuenta', value: '1' }

                //Horario extraordinario OK
                //{ name: 'idServicio', value: '1754' },
                //{ name: 'claveEstablecimiento', value: '30538' },
                //{ name: 'estatusEstadoCuenta', value: 'A' },
                //{ name: 'folioEstadoCuenta', value: 'EXTRA' }

                //Musica viva OK
                //{ name: 'idServicio', value: '1754' },
                //{ name: 'claveEstablecimiento', value: '30538' },
                //{ name: 'estatusEstadoCuenta', value: 'A' },
                //{ name: 'folioEstadoCuenta', value: 'MUSICA' }

                //Constancia uso suelo OK
                //{ name: 'idServicio', value: '1755' },
                //{ name: 'claveEstablecimiento', value: '30538' },
                //{ name: 'estatusEstadoCuenta', value: 'A' },
                //{ name: 'folioEstadoCuenta', value: 'EXTRA' }

                //Anuncios publicitarios ESTABLECIMIENTO OK
                //{ name: 'idServicio', value: '1756' },
                //{ name: 'claveEstablecimiento', value: '30538' },
                //{ name: 'estatusEstadoCuenta', value: 'A' },
                //{ name: 'folioEstadoCuenta', value: 'ESTABLECIMIENTO' }

                //Anuncios publicitarios CLAVE NO SE ABRE EL EDO CUENTA INSERTADO
                //{ name: 'idServicio', value: '1756' },
                //{ name: 'claveEstablecimiento', value: '01010550006000016' },
                //{ name: 'estatusEstadoCuenta', value: 'A' },
                //{ name: 'folioEstadoCuenta', value: 'CLAVE' }

                //Predial 
                //{ name: 'idServicio', value: '2' },
                //{ name: 'claveEstablecimiento', value: '01010410002000003' },
                //{ name: 'estatusEstadoCuenta', value: 'A' },
                //{ name: 'folioEstadoCuenta', value: '1' }
            ];

            campos.forEach(campo => {
                const input = document.createElement('input');
                input.type = 'hidden';
                input.name = campo.name;
                input.value = campo.value;
                formulario.appendChild(input);
            });

            // Añadir el formulario al documento y enviarlo
            document.body.appendChild(formulario);

            // Abrir la ventana emergente
            let ventanaEmergente = window.open('', 'ventanaFlotante', `width = ${ ancho }, height = ${ alto }, top = ${ arriba }, left = ${ izquierda }, resizable = yes, scrollbars = yes`);

            // Enviar el formulario
            formulario.submit();

            // Verificar el estado de la ventana emergente
            const verificarVentana = setInterval(() => {
                // @ts-ignore
                if (ventanaEmergente.closed) {
                    clearInterval(verificarVentana); // Detener el intervalo cuando la ventana se cierra
                    this.dialog = false;
                }
            }, 500); // Verificar cada 500ms si la ventana está cerrada


            // Limpiar el formulario
            document.body.removeChild(formulario);
        },
        pagoEnLinea2() {
            const campos = {
                //Basura OK
                idServicio: this.dataPagoEnlinea.id_servicio,
                claveEstablecimiento: this.dataPagoEnlinea.id_establecimiento,
                estatusEstadoCuenta: this.dataPagoEnlinea.estatus_edo_cuenta,
                folioEstadoCuenta: this.dataPagoEnlinea.folio_estado_cuenta
            };
            this.ventanaPagoEnLinea(this.folioPago);

        },
        ventanaPagoEnLinea(order_id: any) {
            const url = 'https://pagos.smartcaribe.com/api/payment-url';
            const ancho = 800;
            const alto = 600;

            // Centrar la ventana flotante
            const izquierda = (window.screen.width / 2) - (ancho / 2);
            const arriba = (window.screen.height / 2) - (alto / 2);

            const campos = [
                { name: 'order_id', value: order_id },
            ];

            // Crear un formulario y enviarlo en una nueva ventana
            const formulario = document.createElement('form');
            formulario.method = 'post';
            formulario.action = url;
            formulario.target = 'ventanaFlotante';
            formulario.style.display = 'none'; // Ocultar el formulario

            campos.forEach(campo => {
                const input = document.createElement('input');
                input.type = 'hidden';
                input.name = campo.name;
                input.value = campo.value;
                formulario.appendChild(input);
            });
            
            // Añadir el formulario al documento y enviarlo
            document.body.appendChild(formulario);

            // Abrir la ventana emergente
            let ventanaEmergente = window.open('', 'ventanaFlotante', `width = ${ ancho }, height = ${ alto }, top = ${ arriba }, left = ${ izquierda }, resizable = yes, scrollbars = yes`);

            // Enviar el formulario
            formulario.submit();

            // Verificar el estado de la ventana emergente
            const verificarVentana = setInterval(() => {
                // @ts-ignore
                if (ventanaEmergente.closed) {
                    clearInterval(verificarVentana); // Detener el intervalo cuando la ventana se cierra
                    this.dialog = false;
                }
            }, 500); // Verificar cada 500ms si la ventana está cerrada


            // Limpiar el formulario
            document.body.removeChild(formulario);  
        },
        pagoEnLineaPagadoFunction() {
            ViewPDFService.viewPDF(this.tipoPago+'/generarReciboPago/'+this.folioPago+'/'+this.establecimientoPago, {}, 'POST', 'Temp')
            .then((response)=>{
                let file = new Blob([response.data],{type: response.headers['content-type']});
                const url = window.URL.createObjectURL(file);
                const tipoArchivo = 'Titulo'
                //@ts-ignore
                this.documento2 = {
                    title: tipoArchivo,
                    url: url,
                    mime: response.headers['content-type'] 
                }
                this.dialogRecibo = true;
            });
        },
        openNewPaymentFormat(){
            let url = 'https://pagos.smartcaribe.com/api/generate-payment-order-pdf';
            let params = {
                folio: this.folioPago
            };
            let headers = {
                Authorization: `Bearer 2|hc9nMaYIkAkgf9WfoEVTO6qpKpf6TRC3ELJZgEXd0236dcf2`
            };
            axios.post(url, params, {
                headers: headers,
                responseType: 'blob'  // importante para PDFs
            }).then((response) => {
                // Crear un objeto Blob con la respuesta
                let file = new Blob([response.data], { type: response.headers['content-type'] });
                
                // Abrir en una ventana emergente (popup)
                //window.open(fileURL, "_blank", "width=800,height=600");

                const url = window.URL.createObjectURL(file);
                const tipoArchivo = 'Titulo'
                //@ts-ignore
                this.documento = {
                    title: tipoArchivo,
                    url: url,
                    mime: response.headers['content-type'] 
                }
                this.dialogInterno = true;
                this.disabled = false;
            
            }).catch((error) => {
                console.error("Error al generar el PDF:", error);
            });
        }
    }
})
